module.exports = {
  mundipagg: {
    number: "number",
    holderName: "holder_name",
    holderDocument: "holder_document",
    expMonth: "exp_month",
    expYear: "exp_year",
    cvv: "cvv",
    brand: "brand",
    privateLabel: "private_label",
    "billingAddress.line1": "billing_address.line_1",
    "billingAddress.line2": "billing_address.line_2",
    "billingAddress.zipCode": "billing_address.zip_code",
    "billingAddress.city": "billing_address.city",
    "billingAddress.state": "billing_address.state",
    "billingAddress.country": "billing_address.country",
    "options.verifyCard": "options.verify_card",
  },
  stripe: {
    number: "number",
    holderName: "name",
    expMonth: "exp_month",
    expYear: "exp_year",
    cvv: "cvc",
    brand: "brand",
    privateLabel: "private_label",
    "billingAddress.line1": "address_line1",
    "billingAddress.line2": "address_line2",
    "billingAddress.zipCode": "address_zip",
    "billingAddress.city": "address_city",
    "billingAddress.state": "address_state",
    "billingAddress.country": "address_country",
    "options.verifyCard": "options.verify_card",
  },
};

